import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomTabset from "../Components/CustomTabset/CustomTabset";
import {globals} from "../Components/Globals/Globals.js";
import { loadStats } from "../redux/statSlice";

// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import StatsRawTableDataSync from "../Components/StatsRawTableDataSync/StatsRawTableDataSync"

const AdminStatsView = (props) => {
  const dispatch = useDispatch();

  // Get the stats from the store
  const {statsItems, loadStats_result} = useSelector((state) => state.stats)
  
  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true

    // If status is !loading, then fetch stats data from the API
    if (loadStats_result.status === 'idle'){
      if (globals.parameters.redux_debugging) alert("loading stats")
      dispatch(loadStats());
    }

    if (loadStats_result.status === 'loading'){
      if (globals.parameters.redux_debugging) alert("loading stats...")
    }

    // If status is !loading, then fetch stats data from the API
    if (loadStats_result.status === 'succeeded'){
      console.log("AdminStatsView -> statsItems", statsItems)
      if (globals.parameters.redux_debugging) alert("stats successfully loaded")
    }

    // Cleanup function
    return () => {
      isMounted = false
    }
  }, [loadStats_result, dispatch]);


  return (    
        <div className="wrapper">
          <div className="main">
            <div className="section">
              <Container>
                {/** Search toolbar */}
                <CustomTabset activeTabset={"stats"}/>
                <Row>
                  <div>
                      {statsItems  &&
                      <StatsRawTableDataSync
                        stat_list = {statsItems}
                        current_session={null}
                        //stat_filter={stat_or_admin_filter()}
                        stat_filter={null}/>}                 
                </div>
                </Row> 
              </Container>
            </div>
          </div>
        </div>
  );
}

export default AdminStatsView;
